// extracted by mini-css-extract-plugin
export default {"root":"PlasmicLastWeekDataButton_root__kfaKK","text":"PlasmicLastWeekDataButton_text__Uvq2Q"};